import PagesRouter from "./pages/PagesRouter/PagesRouter";
import "./styles/mainAppStyles.css";
import "./styles/root.css";

function App() {
  return (
    <div className="app">
      <PagesRouter />
    </div>
  );
}

export default App;
